
import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/init/init.guard.ts' );

import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppService } from '../commons/app.service';


@Injectable()
export class InitGuard implements CanActivate {
    
    constructor(public service: AppService, public router: Router) {
        DEBUG.log ( '/init/init.guard.ts' );
    }
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        DEBUG.log ( '/init/init.guard.ts', 'canActivate()', { route, state } );
        let subject = new Subject<boolean>();
        // Check the vasat DB is initialized. Note this is weirdly done as the Back-end responses are not quite well defnied yet
        this.service.V.api("/vadmin/dba/initDB", "get").subscribe(
            res => {
                //console.log("ENTER init guard res: ",res)
                if (res["db_url"]) {
                    this.router.navigate(["init","db"])
                    subject.next(false)
                } else {
                    this.checkLicence(subject)
                }
                
            }, err => {

                DEBUG.log ( '/init/init.guard.ts', 'canActivate() ERROR', { err } );

                // Check if error has SyntaxError it is likely the route could not be found or somehow the response was not JSON.
                if (err.status > 6000 && !err.error.toString().includes("SyntaxError")) {
                    this.router.navigate(["init","db"], {queryParams: {status: err.status, msg: err.message} })
                    subject.next(false)
                } else {
                    this.checkLicence(subject)
                }
            }
        )

        return subject

    }

    checkLicence(subject:Subject<boolean>) {
        this.service.V.api("/access/login/website", "get")
            .subscribe(
              res => {
                subject.next(true)
              }, err => {
                // This error status means the user has already logged in, therefore licence must be valid
                if (err.status == 4032) {
                    subject.next(true)
                } else {
                    this.router.navigate(["init","licence"])
                    subject.next(false)
                }
              }
            )
      }
}